module.exports = __webpack_public_path__ + "img/switzerland-transport-accidents-male.e0e6822e.png";